<ng-container *transloco="let t">
    <section class="mb-2">
        <h2 class="text-lg md:text-xl lg:text-2xl font-bold text-gray-800">
            {{ t('store_list') }}
        </h2>
    </section>
    <div class="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <us-shop-card *ngFor="let shop of shops$ | async" [shop]="shop"></us-shop-card>
    </div>
</ng-container>
